module.exports = __webpack_public_path__ + "static/media/favicon-96x96.729a6dd8.png";